/*
 *###############################################################################
 *Module Name                   : CashBookVASCollection.js                               #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  W M Shanika Chamodi                          #
 *Date                          :  Friday, December 12th 2022, 1:16:56 pm         #
 *Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */
import React, { useState } from "react"
import { Row, Col } from "reactstrap"

import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"


const CashBookVASCollection = React.memo(({ DataRow, Disabled, TotalVASValue }) => {
  return (
    <React.Fragment>
      <Row>
        <Col sm={12} md={12} className="mb-12-sm">
          <table
            style={{ fontSize: "12px" }}
            id={"CashBookPOSTradingDet"}

          >
            <thead className="table-light-border">
              <tr>
                <th>Type</th>
                <th>Provider</th>
                <th>Service</th>
                <th>Payment Mode</th>
                <th>Description</th>
                <th style={{ textAlign: "right" }}>Amount</th>

              </tr>
            </thead>
            <tbody disabled={true}>
              {(DataRow || []).map((dataRow, key) => (
                <TableRow FormRow={dataRow} Key={key} Disabled={Disabled} />
              ))}
            </tbody>
            <tfoot>

              <tr>

                <th style={{ textAlign: "left" }}>Total Amount</th>
                <th ></th>
                <th ></th>
                <th ></th>
                <th ></th>
                <th style={{ textAlign: "right" }}>
                  <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    labelText="Code"
                    textType="text"
                    maxLength="8"
                    textAlign="right"
                    disabled={true}
                    defaultValue="0.0"
                    value={TotalVASValue.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
                  ></DPTextBoxforgrid>
                </th>
              </tr>

            </tfoot>
          </table>
        </Col>
      </Row>
    </React.Fragment>
  )
})
export default CashBookVASCollection

const TableRow = ({ FormRow, Key, Disabled }) => {

  const [Type, setType] = useState(
    FormRow.type != undefined ? FormRow.type : ""
  )
  const [Provider, setProvider] = useState(
    FormRow.provider != undefined ? FormRow.provider : ""
  )
  const [Service, setService] = useState(
    FormRow.service != undefined ? FormRow.service : ""
  )
  const [Paymentcode, setPaymentcode] = useState(
    FormRow.paymentcode != undefined ? FormRow.paymentcode : ""
  )
  const [PaymentDescription, setPaymentDescription] = useState(
    FormRow.paymentDescription != undefined ? FormRow.paymentDescription : ""
  )
  const [Amount, setAmount] = useState(
    FormRow.amount != undefined ? FormRow.amount : "0.0"
  )

  return (
    <tr key={FormRow.id}>
      <td style={{ width: "100px" }}>

        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"txtType" + Key}
            value={Type}
            onChange={e => {
              setType(e.target.value)
            }}
          ></DPTextBoxforgrid>
        </Col>

      </td>
      <td style={{ width: "180px" }}>

        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"txtProvider" + Key}
            value={Provider}
            onChange={e => {
              setProvider(e.target.value)
            }}
          ></DPTextBoxforgrid>
        </Col>

      </td>
      <td style={{ width: "180px" }}>

        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"txtService" + Key}
            value={Service}
            onChange={e => {
              setService(e.target.value)
            }}
          ></DPTextBoxforgrid>
        </Col>

      </td>
      <td style={{ width: "100px" }}>

        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"txtPaymentcode" + Key}
            value={Paymentcode}
            onChange={e => {
              setPaymentcode(e.target.value)
            }}
          ></DPTextBoxforgrid>
        </Col>

      </td>
      <td style={{ width: "180px" }}>

        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"txtPaymentDescription" + Key}
            value={PaymentDescription}
            onChange={e => {
              setPaymentDescription(e.target.value)
            }}
          ></DPTextBoxforgrid>
        </Col>

      </td>
      <td style={{ width: "100px" }}>

        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            defaultValue="0.0"
            textAlign="right"
            id={"txtAmount" + Key}
            value={Amount.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
            width="100px"
            disabled={Disabled}

          ></DPTextBoxforgrid>
        </Col>

      </td>



    </tr>
  )
}
